export const implementation = {
  implementationHero: {
    subtitle: 'IMPLEMENTATION',
    title: 'Implementation',
    description: 'Sophisticated System Implementation Roadmap',
  },
  flow: {
    subtitle: 'IMPLEMENTATION FLOW',
    title: 'Implementation Process',
    description: 'We provide a systematic approach from initial consultation to program launch.',
    individual: {
      title: 'Individual',
      steps: [
        {
          number: '01',
          title: 'Initial Consultation',
          description: 'Understanding your current situation and goals',
        },
        {
          number: '02',
          title: 'Program Selection',
          description: 'Selecting the optimal curriculum',
        },
        {
          number: '03',
          title: 'Learning Start',
          description: 'Begin structured learning',
        },
      ],
    },
    corporate: {
      title: 'Corporate',
      steps: [
        {
          number: '01',
          title: 'Organizational Hearing',
          description: 'Understanding organizational challenges and goals',
        },
        {
          number: '02',
          title: 'Customization',
          description: 'Designing optimal programs',
        },
        {
          number: '03',
          title: 'Implementation & Follow-up',
          description: 'Program execution and continuous support',
        },
        {
          number: '04',
          title: 'Contract & Onboarding',
          description: 'Finalizing contract and initiating onboarding',
        },
      ],
    },
    educational: {
      title: 'Educational Institution',
      steps: [
        {
          number: '01',
          title: 'Educational Philosophy Alignment',
          description: 'Confirming alignment with institutional philosophy',
        },
        {
          number: '02',
          title: 'Curriculum Integration',
          description: 'Integrating with existing curriculum',
        },
        {
          number: '03',
          title: 'Educator Training & Launch',
          description: 'Educator training and program launch',
        },
      ],
    },
  },
  faq: {
    subtitle: 'Frequently Asked Questions',
    title: 'Frequently Asked Questions',
    items: [
      {
        question: 'Who is eligible to take the course?',
        answer: 'The program is designed for business leaders seeking to improve organizational productivity, educators nurturing the next generation, and ambitious individuals who wish to redesign their own growth from a "structural" perspective.',
      },
      {
        question: 'Is specialized knowledge in science or psychology required?',
        answer: 'No specialized knowledge is required. DREAM CODE systematizes complex academic insights into "reproducible steps for everyone." We emphasize practical application to your own thinking and behavior rather than memorizing technical terms.',
      },
      {
        question: 'What is the course format?',
        answer: 'We provide video programs featuring lectures and practical workshops. You can learn and practice repeatedly without time or location constraints, adapting to your lifestyle and schedule.',
      },
      {
        question: 'What is the recommended learning period (pace) for all 48 courses?',
        answer: 'The program is designed to progress flexibly according to individual understanding and practice pace. We will propose an optimal schedule during the pre-implementation consultation based on detailed timelines.',
      },
      {
        question: 'Is it possible to customize implementation for corporate training or educational institutions?',
        answer: 'Yes, it is possible. After hearing about your organizational philosophy and current challenges (leadership development, autonomous talent development, etc.), we extract optimal modules from the 48 principles and reconstruct them as a dedicated curriculum.',
      },
      {
        question: 'What are the course fees and enrollment process?',
        answer: 'The course fee for DREAM CODE (all 48 courses, basic program) is ¥440,000 (tax included).\nAt our academy, we place great importance on the compatibility between each applicant\'s current challenges and the program. Please first contact us via "INQUIRY." After a preliminary hearing (or interview), we will individually send you the dedicated enrollment procedures and payment instructions.\n※For customized implementation for corporations and educational institutions, we provide individual quotations based on scale and content.',
      },
    ],
    button: 'Contact Secretariat',
  },
};